import { IApplicationState } from '../../../types/redux';

/**
 * Выбирает состояние рекомендованных объявлений
 */
export const selectOffersFromRecommendedApiStatus = ({
  recommendedOffers: { offersFromRecommendedApi },
}: IApplicationState) => offersFromRecommendedApi.status;
